import React from 'react';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  useDeleteWikiPageItemMutation,
  useGetWikiCategoriesQuery,
  useGetWikiPagesQuery,
} from '../../../../../../redux/services/wikiApi.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';
import { useTranslation } from 'react-i18next';
import PagesTable from './PagesTable.jsx';
import { GroupOutlined } from '@ant-design/icons';
import { ROLE_WIKI_ADMIN } from '../../../../../../utils/constants/roles.js';

const PagePage = () => {
  const navigate = useNavigate();
  const { deleteSuccess } = useToastMessages();
  const { t } = useTranslation();

  const user = useSelector((state) => state.auth.user);
  const isWikiAdmin = user?.roles?.some((r) => r.name === ROLE_WIKI_ADMIN) ?? false;

  const { data: wikiPages, isLoading, refetch } = useGetWikiPagesQuery();
  const { data: wikiCategories } = useGetWikiCategoriesQuery();

  const [deleteWikiPageItem] = useDeleteWikiPageItemMutation();

  const canManageWikiPage = (wikiPage) =>
    isWikiAdmin || wikiPage?.person_id === user?.id;

  const handleDelete = async (id) => {
    try {
      await deleteWikiPageItem(id).unwrap();
      deleteSuccess();
      refetch();
    } catch (err) {}
  };

  if (isLoading) return <Spinner />;

  return (
    <>
      <AppBarCMS
        title={t('FRI.wiki')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať Wiki stránku')}
        createUrl={routes.cmsWikiPageCreate}
        permissionsBasic={'wiki-pages'}
        mainActions={[
          ...(isWikiAdmin
            ? [
                {
                  title: t('Kategórie Wiki stránok'),
                  onClick: () => navigate(routes.cmsWikiCategories),
                  icon: <GroupOutlined />,
                },
              ]
            : []),
        ]}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <PagesTable
            wikiPages={wikiPages}
            wikiCategories={wikiCategories}
            onDelete={(record) => handleDelete(record.id)}
            onDetailClick={(record) => navigate(`${routes.cmsWikiPageDetail}/${record.id}`)}
            onEditClick={(record) => navigate(`${routes.cmsWikiPageEdit}/${record.id}`)}
            secondaryCondition={canManageWikiPage}
            deleteCondition={canManageWikiPage}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default PagePage;
